import { Controller } from "@hotwired/stimulus";

// Captures feature_card_clicked / feature_card_shown for the welcome
// recommendations feature cards (Discovery / Campaigns / Reporting).
// PR #648 originally tracked these via Microsoft Clarity only — this
// pipes them to PostHog so they show up in the activation funnel.
export default class extends Controller {
  static values = {
    card: String,
    available: Boolean,
  };

  connect() {
    this.capture("feature_card_shown");
  }

  click() {
    // The card link navigates away immediately (Turbo visit), which aborts a
    // normally-queued XHR capture before it is sent — feature_card_clicked was
    // never delivered even though feature_card_shown (fired on connect) was.
    // sendBeacon hands the event to the browser and survives the navigation.
    this.capture("feature_card_clicked", { transport: "sendBeacon" });
  }

  capture(eventName, options = {}) {
    if (typeof window.posthog === "undefined") return;
    window.posthog.capture(
      eventName,
      {
        card: this.cardValue,
        available: this.hasAvailableValue ? this.availableValue : true,
        surface: "welcome_recommendations",
      },
      options
    );
  }
}
